import {switchAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system'
import {calc} from '@chakra-ui/theme-tools'
// The imports below are getting icon data urls directly from the package rather than
// using the recommended hooks because this theme is not a function component.
// Do not use this pattern for getting data urls for icons if at all possible. Rather,
// go to ui/lib/utils/design-system/readme.md for correct usage of the hooks.
// @ts-expect-error - see above
import mdCheckIcon from 'airship-design-system/icons/ic_check_mark_16_regular.svg?url'
// @ts-expect-error - see above
import lgCheckIcon from 'airship-design-system/icons/ic_check_mark_24_regular.svg?url'
// @ts-expect-error - see above
import mdCrossIcon from 'airship-design-system/icons/ic_cross_16_regular.svg?url'
// @ts-expect-error - see above
import lgCrossIcon from 'airship-design-system/icons/ic_cross_24_regular.svg?url'

import borders from 'airship/design-system/theme/foundations/borders'
import colors from 'airship/design-system/theme/foundations/colors'
import opacities from 'airship/design-system/theme/foundations/opacity'
import shadow from 'airship/design-system/theme/foundations/shadow'
import size from 'airship/design-system/theme/foundations/sizes'
import {setSvgDataUrlColor} from 'airship/utils/design-system/index'

const iconColor = '#ffffff'
const mdCrossIconWhite = setSvgDataUrlColor(mdCrossIcon, iconColor)
const lgCrossIconWhite = setSvgDataUrlColor(lgCrossIcon, iconColor)
const mdCheckIconWhite = setSvgDataUrlColor(mdCheckIcon, iconColor)
const lgCheckIconWhite = setSvgDataUrlColor(lgCheckIcon, iconColor)

const {definePartsStyle, defineMultiStyleConfig} =
  createMultiStyleConfigHelpers(switchAnatomy.keys)

const baseStyle = definePartsStyle({
  thumb: {
    fill: colors.background.primary,
    alignItems: 'center',
    resize: 'none',
  },
  track: {
    borderRadius: borders.radii.full,
    backgroundColor: colors.background.contrast,
    backgroundPositionY: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: '90%',
    alignItems: 'center',
    resize: 'none',
    _checked: {
      backgroundColor: colors.background.brand,
      backgroundPositionY: 'center',
      backgroundPositionX: '10%',
      backgroundRepeat: 'no-repeat',
      _hover: {
        backgroundColor: colors.background['brand-hover'],
      },
    },
    _disabled: {
      opacity: opacities.disabled,
    },
    _hover: {
      backgroundColor: colors.background['contrast-hover'],
    },
    _focus: {
      shadow: shadow.focus,
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
  },
})

const sizes = {
  sm: definePartsStyle({
    track: {
      height: size['4xs'],
      width: size.xs,
    },
    thumb: {
      height: size['4xs'],
      width: size['4xs'],
      _checked: {
        // using value for track width
        transform: `translateX(${calc.divide(size.xs, 2)})`,
      },
    },
  }),
  md: definePartsStyle({
    track: {
      height: size['3xs'],
      width: size.sm,
      backgroundImage: mdCrossIconWhite,
      _checked: {
        backgroundImage: mdCheckIconWhite,
      },
    },
    thumb: {
      height: size['3xs'],
      width: size['3xs'],
      _checked: {
        transform: `translateX(${calc.divide(size.sm, 2)})`,
      },
    },
  }),
  lg: definePartsStyle({
    track: {
      height: size.xs,
      width: size.lg,
      backgroundImage: lgCrossIconWhite,
      _checked: {
        backgroundImage: lgCheckIconWhite,
      },
    },
    thumb: {
      height: size.xs,
      width: size.xs,
      _checked: {
        transform: `translateX(${calc.divide(size.lg, 2)})`,
      },
    },
  }),
}

const fdDarkBase = definePartsStyle({
  track: {
    backgroundColor: colors.background['contrast-active'],
    _checked: {
      backgroundColor: colors.background['info-active'],
      _hover: {
        backgroundColor: colors.background['info-hover'],
      },
    },
    _hover: {
      backgroundColor: colors.background['contrast-hover'],
    },
  },
})

const SwitchTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: {fdDarkBase},
})

export default SwitchTheme
